<!-- <Flatpickr @data-from-child="handleDataFromChild" :mode="'range'" v-model="selectedDate" /> -->
<!-- const selectedDate = ref('');

const handleDataFromChild = (data) => {
    selectedDate.value = data;  // Get data from child
}; -->
<template>
    <section>
        <div class="form-group">
            <div class="input-group">
                <flat-pickr v-model="date" @on-change="sendDataToParent" :config="config"
                    class="form-control rounded-3 p-2" :class="{ 'is-invalid': hasError }" placeholder="Select date" name="date" />
                <div class="input-group-append">
                    <button class="btn btn-default h-100" id="clearDate" type="button" title="Clear" data-clear>
                        <i class="fa fa-times"></i>
                        <span aria-hidden="true" class="sr-only">Clear</span>
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref } from 'vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/airbnb.css';

// mode = 'single' / 'multiple' / 'range'
const props = defineProps({ hasError: Boolean , mode: String });
const emit = defineEmits();

let date = ref(null);

function sendDataToParent() {
    emit('data-from-child', date);
}

const config = ref({
    wrap: true,
    altFormat: 'd/m/Y',
    altInput: true,
    dateFormat: 'Y-m-d',
    mode: props.mode
});

</script>
